async function getProduct(queryInfo, productInfo) {
  const { BASE_URL, STORE_CODE, AUTH } = queryInfo;
  const { cart_item_id, order_item_id } = productInfo;

  const res = await fetch(
    `${BASE_URL}/${STORE_CODE}/V1/designhub/${
      order_item_id ? `order/${order_item_id}` : `cart/${cart_item_id}`
    }`,
    {
      method: 'GET',
      headers: {
        Authorization: AUTH,
        'Content-Type': 'application/json',
      },
    },
  );

  return res;
}

async function getLogos(queryInfo, productInfo) {
  const { BASE_URL, STORE_CODE, AUTH } = queryInfo;
  const { customer_id } = productInfo;

  const res = await fetch(
    `${BASE_URL}/${STORE_CODE}/V1/designhub/elements/${customer_id}?searchCriteria[filterGroups][0][filters][0][value]=2&searchCriteria[filterGroups][0][filters][0][field]=type_element`,
    {
      method: 'GET',
      headers: {
        Authorization: AUTH,
        'Content-Type': 'application/json',
      },
    },
  );

  return res;
}

async function postNewLogo(queryInfo, productInfo, body) {
  const { BASE_URL, STORE_CODE, AUTH } = queryInfo;
  const { customer_id } = productInfo;
  const res = await fetch(`${BASE_URL}/${STORE_CODE}/V1/designhub/elements/${customer_id}`, {
    method: 'POST',
    headers: {
      Authorization: AUTH,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  return res;
}

async function getPatterns(queryInfo, productInfo) {
  const { BASE_URL, STORE_CODE, AUTH } = queryInfo;
  const { customer_id } = productInfo;

  const res = await fetch(
    `${BASE_URL}/${STORE_CODE}/V1/designhub/elements/${customer_id}?searchCriteria[filterGroups][0][filters][0][value]=1&searchCriteria[filterGroups][0][filters][0][field]=type_element`,
    {
      method: 'GET',
      headers: {
        Authorization: AUTH,
        'Content-Type': 'application/json',
      },
    },
  );
  return res;
}

async function getColors(queryInfo) {
  const { BASE_URL, STORE_CODE, AUTH } = queryInfo;

  const res = await fetch(`${BASE_URL}/${STORE_CODE}/V1/designhub/colors`, {
    method: 'GET',
    headers: {
      Authorization: AUTH,
      'Content-Type': 'application/json',
    },
  });
  return res;
}

async function getStyles(queryInfo, productInfo) {
  const { BASE_URL, STORE_CODE, AUTH } = queryInfo;
  const { product_id } = productInfo;

  const res = await fetch(
    `${BASE_URL}/${STORE_CODE}/V1/products?searchCriteria[filterGroups][0][filters][0][conditionType]=eq&searchCriteria[filterGroups][0][filters][0][field]=entity_id&searchCriteria[filterGroups][0][filters][0][value]=${product_id}`,
    {
      method: 'GET',
      headers: {
        Authorization: AUTH,
        'Content-Type': 'application/json',
      },
    },
  );
  return res;
}
async function getQuickProductInfo(queryInfo, productInfo) {
  const { BASE_URL, STORE_CODE, AUTH } = queryInfo;
  const { cart_item_id } = productInfo;

  const res = await fetch(`${BASE_URL}/${STORE_CODE}/V1/designhub/cart/${cart_item_id}`, {
    method: 'GET',
    headers: {
      Authorization: AUTH,
      'Content-Type': 'application/json',
    },
  });

  return res;
}

async function deleteLogo(queryInfo, productInfo, elementId) {
  const { BASE_URL, STORE_CODE, AUTH } = queryInfo;
  const { customer_id } = productInfo;

  const res = await fetch(
    `${BASE_URL}/${STORE_CODE}/V1/designhub/elements/${customer_id}/${elementId}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: AUTH,
        'Content-Type': 'application/json',
      },
    },
  );

  return res;
}

export {
  getProduct,
  getLogos,
  getPatterns,
  getColors,
  postNewLogo,
  getStyles,
  getQuickProductInfo,
  deleteLogo,
};
